import { SectionHeading } from "./NarrativePresentation";

export const ExecutiveActions = ({ onReviewScenarios, onRevisitBudget }) => {
  if (!onReviewScenarios && !onRevisitBudget) return null;

  return (
    <section aria-labelledby="portfolio-actions-title" className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <SectionHeading eyebrow="Executive Actions" title="Continue the decision review" id="portfolio-actions-title" description="Use connected Decision Center workflows to review the portfolio scope or adjust the allocation input." />
      <div className="mt-5 flex flex-wrap gap-3">
        {onReviewScenarios && <button type="button" onClick={onReviewScenarios} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Review portfolio scenarios</button>}
        {onRevisitBudget && <button type="button" onClick={onRevisitBudget} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Revisit available budget</button>}
      </div>
    </section>
  );
};
